import { render, staticRenderFns } from "./SupplyDemandPanel.vue?vue&type=template&id=3e5870a5&scoped=true"
import script from "./SupplyDemandPanel.vue?vue&type=script&lang=js"
export * from "./SupplyDemandPanel.vue?vue&type=script&lang=js"
import style0 from "./SupplyDemandPanel.vue?vue&type=style&index=0&id=3e5870a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5870a5",
  null
  
)

export default component.exports